import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function Spinner() {
  return <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-blue-50 relative overflow-hidden" data-id="element-404">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-5 overflow-hidden pointer-events-none" data-id="element-405">
        <div className="absolute top-0 left-0 w-full h-full font-mono text-xs text-gray-600 leading-relaxed animate-pulse" data-id="element-406">
          {Array.from({
          length: 20
        }).map((_, i) => <div key={i} className="whitespace-nowrap" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-407">
              01001011 01101110 01101111 01110111 01101100 01100101 01100100
              01100111 01100101
            </div>)}
        </div>
      </div>
      <div className="text-center relative z-10 animate-scale-in" data-id="element-408">
        {/* Premium Animated Spinner */}
        <div className="relative w-20 h-20 mx-auto mb-6" data-id="element-409">
          {/* Outer Ring */}
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full" data-id="element-410"></div>
          {/* Primary Spinning Ring */}
          <div className="absolute inset-0 border-4 border-blue-600 rounded-full border-t-transparent animate-spin" style={{
          animationDuration: '1s'
        }} data-id="element-411"></div>
          {/* Inner Counter-Spinning Ring */}
          <div className="absolute inset-2 border-4 border-blue-400 rounded-full border-t-transparent animate-spin" style={{
          animationDirection: 'reverse',
          animationDuration: '1s'
        }} data-id="element-412"></div>
          {/* Center Pulse */}
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-413">
            <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" data-id="element-414"></div>
          </div>
        </div>
        {/* Loading Text with Fade-in */}
        <div className="space-y-2 animate-fade-in" style={{
        animationDelay: '100ms'
      }} data-id="element-415">
          <h2 className="text-xl font-semibold text-gray-900" data-id="element-416">Loading</h2>
          <p className="text-sm text-gray-600" data-id="element-417">Preparing your workspace...</p>
        </div>
        {/* Animated Dots */}
        <div className="flex justify-center gap-2 mt-4" data-id="element-418">
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{
          animationDelay: '0s'
        }} data-id="element-419"></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{
          animationDelay: '0.2s'
        }} data-id="element-420"></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{
          animationDelay: '0.4s'
        }} data-id="element-421"></div>
        </div>
        {/* Sprinklenet Robot Avatar Watermark */}
        <div className="mt-12 opacity-30 animate-pulse" style={{
        animationDelay: '200ms'
      }} data-id="element-422">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1FrxAsdV23omiQNLw7zxz9/Sprinklenet_AI_Square_800px_Robot_Avatar.jpg" alt="Sprinklenet Robot Avatar" className="w-10 h-10 mx-auto rounded-xl shadow-sm object-cover" data-id="element-423" />
          <p className="text-xs text-gray-500 font-mono mt-2" data-id="element-424">Sprinklenet</p>
        </div>
      </div>
    </div>;
}